// extracted by mini-css-extract-plugin
module.exports = {"ColorPrimary":"#006cfd"};